import { useEffect, useState } from "react"
import { getProject } from "../../api/projects"
import { useNavigate, useParams } from "react-router-dom"
import { ProjectProps } from "../../interfaces/project_types"
import { ProjectForm } from "./Form/ProjectForm"
import { useAuth } from "@/App"
import { EmployeeProps } from "@/interfaces/employee_type"

/**
 * ### [Route for ('/create_project')]
 * 
 * This component shows a ProjectForm component to create a new project.
 * 
 */
export function CreateProject() {
    const [formProps, setFormProps] = useState<ProjectProps>()
    const { template } = useParams<{ template: string }>()
    const { user } = useAuth()

    useEffect(() => {
        if (template) {
            setFormProps({
                template: template,
                project_name: "",
                start_date: new Date().toISOString().split("T")[0],
                manager: user as unknown as EmployeeProps, // Bandaid to fix type error
                isDeadline: false,
            } as ProjectProps)
        }

        console.log("formProps", formProps)
    }, [template, user])
    return (
        <>
        { formProps && <ProjectForm method="POST" formProps={formProps}/> }
        </>
    )
}

/**
 * ### [Route for ('/update_project/id/:id')]
 * 
 *  This component shows a Form component to update an existing project.
 */
export function UpdateProject() {
    const { id } = useParams<string>()

    const [currentProject, setCurrentProject] = useState<ProjectProps>()
    const navigate = useNavigate()

    useEffect(() => {
        if (!id) return

        const fetchProject = async () => {
            try {
                const data = await getProject(id)
                setCurrentProject({...data.data, project_id: id})
            } catch (error) {
                console.error("Error fetching project:", error)
                navigate("/*")
            }
        }

        fetchProject()
    }, [id, navigate])

    return (
        <>
        { currentProject && <ProjectForm method="PUT" formProps={currentProject}/> }
        </>
    )
}